import { Selector } from '@ngxs/store';
import { LeerkrachtenState } from '@store/states/leerkrachten.state';
import { LeerkrachtenStateModel } from '@store/models/leerkrachten.model';

export class LeerkrachtenSelectors {
  @Selector([LeerkrachtenState])
  static leerkrachten(state: LeerkrachtenStateModel) {
    return state.leerkrachten;
  }

  @Selector([LeerkrachtenState])
  static leerkrachtenLoading(state: LeerkrachtenStateModel) {
    return state.loading;
  }

  @Selector([LeerkrachtenState])
  static leerkrachtenError(state: LeerkrachtenStateModel) {
    return state.error;
  }

  @Selector([LeerkrachtenState])
  static leerkrachtenLoaded(state: LeerkrachtenStateModel) {
    return state.loaded;
  }

  @Selector([LeerkrachtenState])
  static selectedLeerkracht(state: LeerkrachtenStateModel) {
    return state.leerkrachten.filter((lk) => lk.persoonId === state.selectedLeerkrachtId)[0];
  }

  @Selector([LeerkrachtenState])
  static leerkrachtenListOfEmailAddresses(state: LeerkrachtenStateModel) {
    return state.leerkrachten.map(lk => lk.email && lk.email.trim()).filter(Boolean);
  }
}
